var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_603)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_485_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.99997C10.5267 3.99997 12.78 5.41997 13.88 7.66663C13.4867 8.47997 12.9333 9.17997 12.2733 9.74663L13.2133 10.6866C14.14 9.86663 14.8733 8.83997 15.3333 7.66663C14.18 4.73997 11.3333 2.66663 8 2.66663C7.15333 2.66663 6.34 2.79997 5.57333 3.04663L6.67333 4.14663C7.10667 4.05997 7.54667 3.99997 8 3.99997ZM7.28667 4.75997L8.66667 6.13997C9.04667 6.30663 9.35333 6.6133 9.52 6.9933L10.9 8.3733C10.9533 8.14663 10.9933 7.90663 10.9933 7.65997C11 6.00663 9.65333 4.66663 8 4.66663C7.75333 4.66663 7.52 4.69997 7.28667 4.75997ZM1.34 2.57997L3.12667 4.36663C2.04 5.21997 1.18 6.3533 0.666666 7.66663C1.82 10.5933 4.66667 12.6666 8 12.6666C9.01333 12.6666 9.98667 12.4733 10.88 12.12L13.16 14.4L14.1 13.46L2.28 1.6333L1.34 2.57997ZM6.34 7.57997L8.08 9.31997C8.05333 9.32663 8.02667 9.3333 8 9.3333C7.08 9.3333 6.33333 8.58663 6.33333 7.66663C6.33333 7.6333 6.34 7.6133 6.34 7.57997V7.57997ZM4.07333 5.3133L5.24 6.47997C5.08667 6.84663 5 7.24663 5 7.66663C5 9.31997 6.34667 10.6666 8 10.6666C8.42 10.6666 8.82 10.58 9.18 10.4266L9.83333 11.08C9.24667 11.24 8.63333 11.3333 8 11.3333C5.47333 11.3333 3.22 9.9133 2.12 7.66663C2.58667 6.7133 3.26667 5.92663 4.07333 5.3133Z",
    fill: "#FFF7EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_485_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/closeEye.b09da959bfd886a26ee6bd956da30072.svg";
export { ForwardRef as ReactComponent };